var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 3C22.4168 3 11 14.3074 11 28.2559C11 32.9206 11.9219 37.7384 14.5673 41.2109L36.5 70L58.4327 41.2109C60.8356 38.0569 62 32.4811 62 28.2559C62.0001 14.3074 50.5833 3 36.5 3ZM36.5 17.6276C42.4257 17.6276 47.231 22.3869 47.231 28.2558C47.231 34.1248 42.4257 38.8841 36.5 38.8841C30.5743 38.8841 25.7691 34.1248 25.7691 28.2559C25.7691 22.3869 30.5743 17.6276 36.5 17.6276Z",
    fill: "#23A6F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.8465398359046032ed7d908d4e80611f.svg";
export { ForwardRef as ReactComponent };